const enum SortOptions {
  START_DATE = 'startDate',
}

export { SortOptions };
